import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { isEmpty, map, reject, size } from "lodash";
import BreadcrumbClient from "../../components/Common/BreadcrumbClient"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getClientDetail } from "../../store/clients/actions"

import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import RsAdNew from "components/buttons/Adnew";
import Swal from 'sweetalert2'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
   Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
} from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup'
import ClientActivityBreadcrumbs from "components/Common/ClientActivityBreadcrumb";
import ClientActivityMenu from "./menu/client-activity-menu";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import moment from "moment";
import RichTextEditor from "components/dropdowns/ContentEditor";
import Dropzone from "react-dropzone"
import SafeHTML from "components/buttons/SafeHTML";
import ComposeClientMail from "components/dropdowns/ComposeEmailClient";
import SafeField from "helpers/SafeField";
import EmailActivityList from "components/dropdowns/EmailExpand";
class ClientInbox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      resultArray: [],
      isLoading: false,
      agentData: '',
      currentPage: 1,
      totalPages: 1,
      totalEmails: 0,
      selectedEmails: [],
      showCompose: false,
    }

       this.togglemodal.bind(this)
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail } = this.props;
    onGetClientDetail(params.clientId);

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const userId = localStorage.getItem("userId");

    if (!this.state.agentData) {
      this.setState({ isLoading: true });
      axios.get(`${API_URL}Agent/${userId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => {
          this.setState({ agentData: res.data, isLoading: false });
        })
        .catch(error => {
          console.error('Error fetching agent data:', error);
          this.setState({ isLoading: false });
        });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.agentData &&
      this.props.clietDetail?.prefferedEmail &&
      (prevState.agentData !== this.state.agentData ||
        prevProps.clietDetail?.prefferedEmail !== this.props.clietDetail?.prefferedEmail)
    ) {
      const agentId = this.state.agentData.agentId;
      this.fetchInboxMails(agentId, this.props.clietDetail.prefferedEmail, this.state.currentPage);
    }
  }
  fetchInboxMails(agentId, email, page) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;

    axios.get(`${API_URL}Gmail/GetMailFromByFromEmailPagination/${agentId}/${email}/${page}/20/false/false`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(secondResponse => {
        

        this.setState({
          inboxMails: secondResponse.data.items,
          totalPages: secondResponse.data.totalPages || 1,
          isLoading: false,
          totalEmails: secondResponse.data.totalPages
        });
      })
      .catch(error => {
        console.error('Error fetching data from second API:', error);
        this.setState({ isLoading: false });
      });
  }

  handleCheckboxChange = (emailId) => {
    this.setState((prevState) => {
      const selectedEmails = [...prevState.selectedEmails];
      if (selectedEmails.includes(emailId)) {
        selectedEmails.splice(selectedEmails.indexOf(emailId), 1);
      } else {
        selectedEmails.push(emailId);
      }
      return { selectedEmails };
    });
  };
  handleDelete = async () => {
    const { selectedEmails } = this.state;

    if (selectedEmails.length === 0) {
      Swal.fire({
        title: 'No emails selected',
        text: 'Please select emails to delete.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }


    //const confirmed = window.confirm("Are you sure you want to delete the selected emails?");
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this action!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });
    if (result.isConfirmed) {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        for (let emailId of selectedEmails) {
          const url = `${API_URL}Gmail/DeleteGoogleEmail/${this.state?.agentData?.agentId}/${emailId}/1`;
          await axios.get(url, { headers });
          this.setState((prevState) => {
            const updatedMails = prevState.inboxMails.filter(
              (inbox) => inbox.messageID !== emailId
            );
            return { inboxMails: updatedMails };
          });
        }
        this.setState({ selectedEmails: [] });

      } catch (error) {
        console.error("Error deleting emails", error);
        alert("An error occurred while deleting emails.");
      }
    }
  };
    togglemodal = () => {
      this.setState(prevState => ({
        modal: !prevState.modal,
      }))
    }
    handleSubmit(value) {
      this.setState({ isLoading: true });
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const payload = {
        //name: value.name,
        //from:value.from,
        to: value.to,
        cc: value.cc,
        bcc: value.bcc,
        subject:value.subject,
        body:value.body,
        agentId:value.agentId
      }
      axios.post(`${API_URL}Gmail`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(response => {
        
        this.setState({ isLoading: false });
        this.togglemodal();
      })
      .catch(error => {
        console.error("API Error:", error);
        this.setState({ isLoading: false });
      });
    }
  render() {
    const { clietDetail, userdetail, isResponsive } = this.props;
    const { inboxMails, isLoading, currentPage, totalPages,  agentData } = this.state;
    const { selectedEmails, showCompose } = this.state;
    return (
      <React.Fragment>

        <ToastContainer autoClose={2000} />
   <Modal
                  isOpen={this.state.modal}
                  role="dialog"
                  autoFocus={true}
                  centered={true}
                  className="exampleModal"
                  tabIndex="-1"
                  toggle={this.togglemodal}
                >
                  <div className="modal-content">
                    <ModalHeader toggle={this.togglemodal}>New Message</ModalHeader>
                    <ModalBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        //name:'Sudhir',
                        //from:'sudhir.singh76@gmail.com',
                        to: '',
                        cc:'',
                        bcc:'',
                        subject: '',
                        agentId: this.state?.agentData?.agentId,
                        files: []
                      }}
                      validationSchema={Yup.object().shape({
                        to: Yup.string().email('Invalid email format').required('Email is required'),
                        cc: Yup.string().email('Invalid email format'),
                        bcc: Yup.string().email('Invalid email format'),
                        subject: Yup.string().required('Subject is required'),
                       
                      })}
                      onSubmit={(values, { setSubmitting }) => {
                        toast.loading("Please wait...");
                        const obj = JSON.parse(localStorage.getItem("authUser"));
                        const token = obj?.resultData?.bearerToken;
                        const formData = new FormData();
                        formData.append('to', values.to);
                        formData.append('cc', values.cc || '');
                        formData.append('bcc', values.bcc || '');
                        formData.append('subject', values.subject);
                        formData.append('body', values.body);
                        formData.append('agentId', values.agentId);
                        values.files.forEach((file) => {
                          formData.append('files', file, file.name);
                        });
                        this.setState({ isLoading: true });
                        axios
                          .post(`${API_URL}Gmail`, formData, {
                            headers: {
                              'Content-Type': 'multipart/form-data',
                              Authorization: `Bearer ${token}`,
                            },
                          })
                          .then((response) => {
                             toast.dismiss();
                              toast.success("Saved successfully");
                               
                            this.setState({ isLoading: false });
                            this.togglemodal();
                          
                          })
                          .catch((error) => {
                            console.error('Upload error:', error);
                            this.setState({ isLoading: false });
                          })
                          .finally(() => {
                            setSubmitting(false);
                          });
                      }}
                  
                  >
                      {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                <Form>
                  <div className="mb-3">
                    <Label htmlFor="to" className="form-label">To *</Label> 
                    <SafeField
                      name="to"
                      type="email"
                      className="form-control"
                      onChange={handleChange}
                    
                    />
                    <ErrorMessage name="to" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="cc" className="form-label">CC</Label>
                    <SafeField
                      name="cc"
                      type="email"
                      className="form-control"
                      onChange={handleChange}
                     
                    />
                    <ErrorMessage name="cc" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="bcc" className="form-label">BCC</Label>
                    <SafeField
                      name="bcc"
                      type="email"
                      className="form-control"
                      onChange={handleChange}
                     
                    />
                    <ErrorMessage name="bcc" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                    <Label htmlFor="subject" className="form-label">Subject *</Label>
                    <SafeField
                      name="subject"
                      type="text"
                      className="form-control"
                      onChange={handleChange}
                    
                    />
                    <ErrorMessage name="subject" component="div" className="text-danger" />
                  </div>
                    
                  <div className="mb-3">
                    <label>Message</label>
                      <RichTextEditor
                      name="body"
                      setFieldValue={setFieldValue}
                      initialContent={values.body}
                      placeholder="Enter your  email content..."
                    />
                    
                    <ErrorMessage name="body" component="div" className="text-danger" />
                  </div>
                  <div className="mb-3">
                  <label>Attached Files</label>
                  <Dropzone
                      onDrop={(acceptedFiles) => {
                        setFieldValue('files', [...(values.files || []), ...acceptedFiles]);
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div className="dz-message needsclick" {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <ul className="mt-2">
                  {Array.isArray(values.files) &&
                    values.files.map((file, index) => (
                      <li key={index} className="d-flex align-items-center">
                        <span className="me-2">{file.name}</span>
                        <span className="float-end"> 
                          <button
                          type="button"
                          className="btn btn-sm"
                          onClick={() => {
                            // Remove file from the list
                            const updatedFiles = values.files.filter((_, i) => i !== index);
                            setFieldValue('files', updatedFiles);
                          }}
                        >
                          <i className="fas fa-window-close "></i>
                        </button></span>
                       
                      </li>
                    ))}
                </ul>
                  </div>    
                  <ModalFooter>
                    <Button type="button" color="secondary" onClick={this.togglemodal}>
                      Close
                    </Button>
                    <Button type="submit" color="primary">
                      Send <i className="fab fa-telegram-plane ms-1"></i>
                    </Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
                    </ModalBody>
                    
                  </div>
                </Modal>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
                <Row className="project-header">
                  <Col sm="8">
                    <ClientActivityBreadcrumbs
                      title={this.props.t("Clients")}
                      breadcrumbItem={this.props.t(clietDetail.firstName + " " + clietDetail.lastName + " Appointment")}
                    />
                  </Col>
                  <Col sm="4">
                    <div className="d-flex justify-content-between align-items-center pt-2 mt-2">
                      <h2 className="mb-0 mt-0">
                        {clietDetail.firstName} {clietDetail.lastName}
                      </h2>

                    </div>
                  </Col>
                </Row>

                <ClientActivityMenu userdetail={userdetail} isResponsive={isResponsive} />
                <Row>
                  <Col xl="12">

                     <button 
                      className="btn btn-light same-size-btn"
                      //onClick={this.togglemodal}
                      onClick={() => this.setState({ showCompose: true })}
                      style={{marginBottom:20}}
                    >
                      <i className="bx bx-envelope"></i> Compose
                    </button>

                    <Card className="border-full">
                      <CardBody>
                        {/* <div className="btn-group me-2 mb-2 mb-sm-0">

                          {selectedEmails.length > 0 && (
                            <Button type="button" color="primary" onClick={this.handleDelete}>
                              <i className="far fa-trash-alt" />
                            </Button>
                          )}
                        </div>
                        <ul className="message-list message-list-client">
                          {map(inboxMails, (inbox, key) => {
                            const createdOnDate = moment(inbox.createdOn);
                            const isToday = createdOnDate.isSame(moment(), 'day');

                            return (
                              <li key={key}
                                style={
                                  Number(inbox.customEmailTemplateId) > 0 // Convert to number for comparison
                                    ? { backgroundColor: "lavender", color: "black" } // Style for condition true
                                    : { backgroundColor: "white", color: "black" }   // Style for condition false

                                }>
                                <div className="col-mail col-mail-1 client-mail">
                                  <div className="checkbox-wrapper-mail">
                                    <Input type="checkbox" id={inbox.messageID}
                                      onChange={() => this.handleCheckboxChange(inbox.messageID)}
                                      checked={selectedEmails.includes(inbox.messageID)}
                                    />

                                    <Label htmlFor={inbox.messageID} className="toggle" />
                                  </div>
                                  <Link style={{left:'50px !important'}} to={`/email-read/${inbox.emailDetailId}`} className="title">
                                    {inbox.from}
                                  </Link>
                                 
                                </div>
                                <div className="col-mail col-mail-2 client-mail" style={{left:'300px !important'}}>
                                  <SafeHTML html={inbox.subject} />
                                 
                                  <div className="date">
                                    {isToday
                                      ? createdOnDate.format('h:mm A')
                                      : createdOnDate.format('MMM DD')}

                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul> */}

                           <EmailActivityList inboxMails={inboxMails} lead={clietDetail} agentData={userdetail} />

                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>

            </Row>

          </Container>
        </div>

         {showCompose && (
                  <ComposeClientMail
                    agentData={userdetail}
                    clientDetail={clietDetail}
                    
                    onClose={() => this.setState({ showCompose: false })}
                  />
                )}
      </React.Fragment>
    )
  }
}
ClientInbox.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  onGetClientDetail: PropTypes.func,
  clietDetail: PropTypes.object,
  loading: PropTypes.object,
  userdetail: PropTypes.object,
  isResponsive: PropTypes.object
}
const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail,
    loading: Clients.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId))
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientInbox))
